import React from 'react'

import { string, bool, node } from 'prop-types'
import Collapsible from 'react-collapsible'
import { Tooltip } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import Icon from 'Pods/Shared/Icon/Icon'

function CollapsibleSection({
  sectionSlug,
  trigger,
  hasTooltip = false,
  children,
  button = null,
}) {
  function renderTrigger() {
    return (
      <div className="collapsible-trigger">
        <div className="collapsible-trigger__content">
          {trigger}
          {hasTooltip && (
            <Tooltip
              id={`${sectionSlug}-tooltip`}
              content={window.I18n.t(`tooltips.publisher.${sectionSlug}`)}
              tooltipClassName="tooltip--normal-weight"
            >
              <Icon
                type={['fas', 'info-circle']}
                color="grey"
                className="ml-5"
              />
            </Tooltip>
          )}
          {button && (
            <div className="collapsible-trigger__button">{button}</div>
          )}
        </div>
      </div>
    )
  }

  return (
    <Collapsible
      className="Collapsible--transparent"
      openedClassName="Collapsible--transparent is-opened"
      overflowWhenOpen="visible"
      trigger={renderTrigger()}
      transitionTime={300}
      open
    >
      {children}
    </Collapsible>
  )
}

CollapsibleSection.propTypes = {
  sectionSlug: string.isRequired,
  trigger: string.isRequired,
  hasTooltip: bool,
  children: node.isRequired,
  button: node,
}

export default CollapsibleSection
